<!-- START WOAHbar FOR DESKTOP  -->

if ( $(window).width() > 739) {      
  //Add your javascript for large screens here 
  
  var stub_showing = false;
 
    function woahbar_show() { 
        if(stub_showing) {
          $('.woahbar-stub').slideUp('fast', function() {
            $('.woahbar').show('bounce', { times:3, distance:15 }, 300);
            $('body').animate({"marginTop": "20px"}, 300);
          }); 
        }
        else {
          $('.woahbar').show('bounce', { times:3, distance:15 }, 500);
          $('body').animate({"marginTop": "20px"}, 250);
        }
    }
 
    function woahbar_hide() { 
        $('.woahbar').slideUp('fast', function() {
          $('.woahbar-stub').show('bounce', { times:3, distance:15 }, 100);
          stub_showing = true;
        }); 
 
        if( $(window).width() > 1024 ) {
          $('body').animate({"marginTop": "-20px"}, 250); // if width greater than 1024 pull up the body
        }
    }
 
    $().ready(function() {
        window.setTimeout(function() {
        woahbar_show();
     }, 0); // change this from "0" to any number in milliseconds to delay WOAHbar from showing right away
    });

} 
else {
  //Add your javascript for small screens here 
}  
  
  
<!-- END WOAHbar FOR DESKTOP - START WOAHbar FOR MOBILE  -->
